import PropTypes from 'prop-types'
import React from 'react'
import ReactTooltip from 'react-tooltip'

export const Item = ({feature, hint}) => (
  <li>
    <ReactTooltip delayShow={500} />
    <i className='ico-ima ico' />
    <p data-tip={hint}>{feature}</p>
  </li>
)

Item.propTypes = {
  feature: PropTypes.string.isRequired,
  hint: PropTypes.string
}
